package org.zest.insan_360_website.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleRight
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.s
import org.zest.insan_360_website.components.layouts.assessmentWordLibrary
import org.zest.insan_360_website.data.localized
import org.zest.insan_360_website.data.page_states.CreditState.isSessionExpired
import org.zest.insan_360_website.pages.ButtonStyle
import org.zest.insan_360_website.pages.FadeInSlideKeyframes
import org.zest.insan_360_website.pages.LeftAngleMovementKeyframes
import org.zest.insan_360_website.pages.RightAngleMovementKeyframes

@Composable
fun ProgressButtonRow(
    questionIndex: Int,
    isHoveredLeft: Boolean,
    isHoveredRight: Boolean,
    isAllAnswered: Boolean,
    questionSize: Int,
    onIndexChanged: (Int) -> Unit,
    onHoveredLeft: (Boolean) -> Unit,
    onHoveredRight: (Boolean) -> Unit,
    onFinished: () -> Unit,
) {

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
            .justifyContent(if (questionIndex == 0) JustifyContent.End else JustifyContent.SpaceBetween)
    ) {
        if (questionIndex != 0) {
            Button(
                modifier = Modifier
                    .backgroundColor(Colors.Transparent)
                    .onMouseEnter { onHoveredLeft(true) }
                    .onMouseLeave { onHoveredLeft(false) }
                    .animation(FadeInSlideKeyframes.toAnimation(0.25.s))
                    .then(ButtonStyle.toModifier()),
                onClick = {
                    if (questionIndex > 0) {
                        onIndexChanged(questionIndex - 1)
                        onHoveredLeft(false)
                    }
                },
                enabled = !isSessionExpired
            ) {
                Row(
                    modifier = Modifier.gap(0.5.cssRem),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FaAngleLeft(
                        modifier = Modifier
                            .fontSize(1.5.cssRem)
                            .thenIf(isHoveredLeft) {
                                Modifier.animation(
                                    LeftAngleMovementKeyframes.toAnimation(
                                        duration = 0.5.s,
                                        iterationCount = AnimationIterationCount.Infinite
                                    )
                                )
                            }
                    )
                    SpanText(
                        modifier = Modifier
                            .fontSize(1.5.cssRem),
                        text = assessmentWordLibrary.previous.localized
                    )
                }
            }
        }
        Button(
            modifier = Modifier
                .backgroundColor(Colors.Transparent)
                .onMouseEnter { onHoveredRight(true) }
                .onMouseLeave { onHoveredRight(false) }
                .then(ButtonStyle.toModifier()),
            onClick = {
                if (questionIndex < questionSize - 1) {
                    onIndexChanged(questionIndex + 1)
                    onHoveredRight(false)
                } else if (questionIndex == questionSize - 1) {
                    onFinished()
                }
            },
            enabled =
                if (questionIndex == questionSize - 1) isAllAnswered && !isSessionExpired
                else !isSessionExpired
        ) {
            Row(
                modifier = Modifier.gap(0.5.cssRem),
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(
                    modifier = Modifier
                        .fontSize(1.5.cssRem),
                    text =
                        if (questionIndex != questionSize - 1) assessmentWordLibrary.next.localized
                        else assessmentWordLibrary.finish.localized
                )
                FaAngleRight(
                    modifier = Modifier
                        .fontSize(1.5.cssRem)
                        .thenIf(isHoveredRight) {
                            Modifier.animation(
                                RightAngleMovementKeyframes.toAnimation(
                                    duration = 0.5.s,
                                    iterationCount = AnimationIterationCount.Infinite
                                )
                            )
                        }
                )
            }
        }
    }
}